import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import Tooltip from './Tooltip';
import './stylesheets/Icon.scss';

export default function Icon(props) {
  const {
    className,
    icon,
    muted,
    tooltip,
    svgProps,
    onClick
  } = props;
  const classes = { loc: true, icon: true, muted };

  const theIcon = (
    <svg
      onClick={onClick}
      {...svgProps}
      className={classNames(classes, className)}
    >
      <use xlinkHref={`#common-${icon}`} />
    </svg>
  );

  if (!tooltip) return theIcon;
  return (
    <Tooltip content={tooltip}>
      { theIcon }
    </Tooltip>
  );
}

Icon.propTypes = {
  /** Additional className to customize style */
  className: PropTypes.string,
  /** The icon identifier **/
  icon: PropTypes.string.isRequired,
  /** Use a lighter gray color */
  muted: PropTypes.bool,
  /** Content for the tooltip of the icon */
  tooltip: PropTypes.node,
  svgProps: PropTypes.object //eslint-disable-line
};

Icon.defaultProps = {
  onClick: () => {}
};
